import useSWR from "swr"
import {API_TEAMS} from "../constants/apiUrls"

export default function useTeamOverview(teamID) {
    const {data, mutate, error} = useSWR(`${API_TEAMS}/${teamID}/overview`)
    return {
        teamOverview: data,
        mutateTeamOverview: mutate,
        isLoadingTeamOverview: !error && !data,
        isErrorTeamOverview: error
    }
}